<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :title="title" :visible="visible" width="44rem" top="10vh" @close="close">
    <hic-print-simple :tmpl-code="tmplCode" :print-data="printData" ref="printer" :loading="loading">
      <template #tools>
        <b class="sub-title">{{ hospitalization.patientName }} {{ hospitalization.bedNo }}床 {{ hospitalization.patientAge }}</b>
      </template>
      <el-radio-group v-model="range" size="mini" @change="loadData" class="bottom-pad">
        <el-radio v-if="selected && selected.length" label="selected">选中项</el-radio>
        <el-radio label="all">全部</el-radio>
        <el-radio label="printable">未打印</el-radio>
        <el-radio label="condition">查询条件</el-radio>
      </el-radio-group>
    </hic-print-simple>

    <div slot="footer">
      <el-button type="info" size="large" @click.native="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import api from "../api";
import { mapGetters } from "sw-hic";
export default {
  components: {},
  props: {
    visible: Boolean,
    hospitalization: Object,
    selected: Array,
    type: String,
    condition: Object,
  },
  data() {
    return {
      range: "all",
      loading: false,
      entities: {},
      con: {
        states: ["启用", "待停止", "停止"],
        sort: "no",
        asc: true,
      },
      printData: {},
    };
  },
  computed: {
    ...mapGetters(["dict", "Enum", "dictEnum", "user", "permission"]),
    tmplCode() {
      return this.type == "长期" ? "ChangQiYiZhu" : "LinShiYiZhu";
    },
    title() {
      return this.type == "长期" ? "长期医嘱" : "临时医嘱";
    },
  },
  methods: {
    open() {
      if (this.selected && this.selected.length) {
        this.range = "selected";
      } else {
        this.range = "all";
      }
      this.loadData();
    },
    close() {
      this.$emit("update:visible", false);
    },
    loadData() {
      if (this.range == "selected") {
        this.makePrintData(this.selected);
        return;
      }
      this.loading = true;
      let con = { ...this.con, hospitalizationId: this.hospitalization.id };
      if (this.range == "printable") {
        con.ifPrint = false;
      } else if (this.range == "condition") {
        con = { ...this.condition };
      }
      con.pageSize = 99999999;
      con.term = this.type;
      con.ifMasterSlave = true;
      api.Advice.query(con)
        .then((res) => {
          if (res.items.length) {
            this.makePrintData(res.items);
            // this.$refs.printer.preview();
          } else {
            this.$message.warning("没有数据");
            this.printData = {
              Master: {
                deptName: this.user.deptName,
                ...this.hospitalization,
              },
              Detail: [],
            };
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    makePrintData(items) {
      this.printData = {
        Master: {
          deptName: this.$utils.Dict.text(this.hospitalization.deptCode, "Dept"),
          ...this.hospitalization,
        },
        Detail: items.map((item) => ({
          ...item,
          stDt: this.$utils.Fmt.date(item.issuedTime),
          stTm: this.$utils.Fmt.time(item.issuedTime),
          edDt: this.$utils.Fmt.date(item.stopTime),
          edTm: this.$utils.Fmt.time(item.stopTime),
          execTime: this.$utils.Fmt.datetime(item.execTime),
          startDoctorName: item.doctorName,
          startNurseName: item.issuedNurseName,
          endDoctorName: item.stopDoctorName,
          endNurseName: item.stopNurseName,
          content: this.genContent(item),
        })),
      };
    },
    getFrequencyName(code) {
      let f = this.dict.DrugFrequency.find((item) => item.code == code);
      if (!f) {
        return code;
      }
      return `${f.shortCode} ${f.text}`;
    },
    genContent(item) {
      let content = "";
      if (item.rpClass == "药品") {
        content = `${item.name}${item.standard || ""} ${item.dosagePerTime || ""}${item.dosageUnit || item.minUnit || ""}/次 ${this.getFrequencyName(item.frequency) || ""}`;
      } else if (item.rpClass == "草药") {
        if (item.ifDetail) {
          content = `${item.name}${item.standard || ""} ${item.quantity || ""}${item.unit || ""}`;
        } else {
          content = `${item.name}${item.standard || ""} ${item.dosagePerTime || ""}${item.dosageUnit || item.minUnit || ""}/次 ${this.getFrequencyName(item.frequency) || ""}`;
        }
      } else {
        content = item.name;
      }

      if (item.items && item.items.length) {
        item.items.forEach((i) => {
          content += `，${this.genContent(i)}`;
        });
      }
      console.log(content);
      return content;
    },
  },
};
</script>
